export const UPDATE_ADMIN_FORM = 'UPDATE_ADMIN_FORM';
export const UPDATE_MD_FORM = 'UPDATE_MD_FORM';
export const UPDATE_ADMIN_FORM_ERROR = 'UPDATE_ADMIN_FORM_ERROR';
export const UPDATE_MD_FORM_ERROR = 'UPDATE_MD_FORM_ERROR';

  export const updateAdminForm = ({key, value}) => ({
    type: UPDATE_ADMIN_FORM,
    payload: {key, value}
  });
  export const updateAdminFormError = ({key, value}) => ({
    type: UPDATE_ADMIN_FORM_ERROR,
    payload: {key, value}
  });

  export const updateMDForm = ({key, value}) => ({
    type: UPDATE_MD_FORM,
    payload: {key, value}
  });

  export const updateMDFormError = ({key, value}) => ({
    type: UPDATE_MD_FORM_ERROR,
    payload: {key, value}
  });